import { atom } from "recoil";
export const hotelAtoms = atom({
  key: "hotelAtoms", // unique ID (with respect to other atoms/selectors)
  default: [], // default value (aka initial value)
});
